<template lang="pug">
	nav(class="mobile-menu" id="menu")
		router-link(to="/" class="sidebar-toggle") Главная
		router-link(to="/faq" class="sidebar-toggle") ЧаВо
		router-link(to="/about" class="sidebar-toggle") О школе
		router-link(to="/schedule" class="sidebar-toggle") Расписание
		router-link(to="/links" class="sidebar-toggle") Полезные ссылки
		.mobile-menu__register(@click="toggleSignup") Записаться
</template>

<script>
import { mapMutations } from "vuex";
export default {
	name: "mobileMenu",
	props: {
		msg: String
	},
	methods:{
		...mapMutations({toggleSignup:"main/toggleSignup"}),
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.mobile-menu
	padding 20px
	box-sizing border-box

	a
		color white
		display block
		margin-bottom 20px
		font-family Oswald
		font-size 25px
		text-decoration none
		text-transform uppercase

	&__register
		font-family: Oswald;
		font-size: 25px;
		background-color: #71356f;
		color: #fff;
		text-transform: uppercase;
		display: inline-block;
		padding: 4px 10px;
		margin-top: 20px;
		margin-left: -10px;
		cursor pointer


</style>
